module.exports = __webpack_public_path__ + "assets/img/20230517.86585166.png";